import React, { FC } from 'react';
import OngoingOrderDialog from './ongoing-order-dialog.component';
import { OperationType } from 'hooks/useOngoingOrderDialog';
import { Order } from 'models/order';

export type OngoingDialogContainerProps = {
    open: boolean;
    orders: Order[];
    operationType: OperationType;
    onClose: () => void;
    onHandleOperation: () => void;
};

const OngoingOrderDialogContainer: FC<OngoingDialogContainerProps> = ({
    open,
    orders,
    operationType,
    onClose,
    onHandleOperation,
}) => {
    return (
        <OngoingOrderDialog
            open={open}
            orders={orders}
            operationType={operationType}
            onClose={onClose}
            onHandleOperation={onHandleOperation}
        />
    );
};
export default OngoingOrderDialogContainer;
